
<div [ngClass]="isRetained? 'page-header-container retained-margin-top' : 'page-header-container'">
  <div>
    @if (isRetained) {
      <p [innerHTML]="'landing-page.logib.header.title' | translate"></p>
      <h5 translate>landing-page.logib.chooseAnVersionOption</h5>
      <mat-form-field>
        <mat-label translate>landing-page.logib.chooseAnVersionOption</mat-label>
        <mat-select [disabled]="false" [(value)]="version" (valueChange)="selectionChange($event)">
          <mat-option [value]="''">
            {{'landing-page.logib.version.auswaehlen' | translate}}
          </mat-option>
          @for (version of versions; track version) {
            <mat-option [value]="version.value">
              {{ "i18n.home.temporary-information.option-release" | translate: { version: version.value.replaceAll('v', '').replaceAll('-', '.') } }} {{version.caption}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  <div [ngClass]="isRetained? 'card-div-container retained': 'card-div-container'">
    <a [href]="selectedVersionUrl" class="ob-link-card"  [ngClass]="{'isDisabled':!version && isRetained}">
      <mat-card>
        <mat-card-header>
          <mat-card-title><h3 translate>landing-page.logib.header</h3></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p translate>landing-page.logib.copy</p>
        </mat-card-content>
        <mat-card-actions>
          <a mat-button obButton="primary" [href]="selectedVersionUrl" [disabled]="!version && isRetained">
            <mat-icon svgIcon="login"></mat-icon>
            {{ "landing-page.enter" | translate }}
          </a>
        </mat-card-actions>
      </mat-card>
    </a>
    @if (!isRetained) {
      <a class="ob-link-card" [href]="getLogsysUrl()">
        <mat-card>
          <mat-card-header>
            <mat-card-title><h3 translate>landing-page.logsys.header</h3></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p translate>landing-page.logsys.copy</p>
          </mat-card-content>
          <mat-card-actions>
            <a mat-button obButton="primary" [href]="getLogsysUrl()" [disabled]="!version && isRetained">
              <mat-icon svgIcon="login"></mat-icon>
              {{ "landing-page.enter" | translate }}
            </a>
          </mat-card-actions>
        </mat-card>
      </a>
    }
  </div>
</div>
